export function createPulseApi(baseUrl) {
  return {
    pulse: {
      getDirections: `${baseUrl}/v1/projects/tags/pulse/`,
      getFunds: `${baseUrl}/v1/funds/`,
      addSubscription: `${baseUrl}/v2/profile/pulse/`,
    },
  };
}
